<template>
  <div class="main-container">
    <div class="search-box">
      <div class="input-item">
        <span class="label">结算周期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.settlementDate"
          @on-change="searchParams.settlementDate = $event"
        ></DatePicker>
      </div>

      <div class="input-item">
        <span class="label">结算机构</span>
        <selectTree v-model="searchParams.orgIds" type="4" :maxTagCount="1" :multiple="true" ref="selectTreeRef"> </selectTree>
      </div>

      <div class="btn-item">
        <Button type="primary" @click="searchAjax">查询</Button>
        <Button type="primary" class="btn-reset" ghost @click="resetSearch">重置</Button>
      </div>
    </div>

    <div class="tableBox">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="toDetailPage(row)">详情</span>
          <span class="table-btn" @click="payment(row)" v-if="row.settlementStatus == 1 && row.orgIdStr.includes(userInfo.organId)">{{
            row.refundedStatus == 0 ? '回款' : '取消回款'
          }}</span>
          <span class="table-btn" @click="toBillDetail(row)">明细</span>
        </template>
      </Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
    </div>
  </div>
</template>

<script>
import selectTree from '@/components/system/selectTree3';
import { pageTool, common } from '@/api/mixins';
import { mapState } from 'vuex';
import filter from '@/api/filter';

export default {
  mixins: [pageTool, common],
  components: {
    selectTree
  },
  computed: {
    ...mapState(['userInfo'])
  },
  data() {
    return {
      searchParams: {},
      columns: [
        {
          title: '结算周期',
          align: 'center',
          key: 'settlementDate',
          minWidth: 120,
          render(h, params) {
            let settlementDate = params.row.settlementDate;
            return <span>{filter.filterTime(settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '结算机构',
          align: 'center',
          key: 'orgName',
          minWidth: 200,
          tooltip: true,
          tooltipMaxWidth: 700
        },
        {
          title: '保单数',
          align: 'center',
          key: 'policyNum',
          minWidth: 100
        },
        {
          title: '批单数',
          align: 'center',
          key: 'billNum',
          minWidth: 100
        },
        {
          title: '总保费',
          align: 'center',
          key: 'fee',
          minWidth: 130
        },
        {
          title: '费用费用合计',
          align: 'center',
          key: 'netIncome',
          minWidth: 120
        },
        {
          align: 'center',
          minWidth: 170,
          render(h, params) {
            let refundedStatus = params.row.refundedStatus;
            return <span>{refundedStatus == 0 ? '未回款' : '已回款'}</span>;
          },
          renderHeader: (h, params) => {
            return (
              <div>
                <span>是否回款</span>
              </div>
            );
          }
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 180,
          fixed: 'right'
        }
      ],
      total: 0,
      tableData: []
    };
  },
  activated(){
    this.getList();
  },
  created() {
    this.searchAjax();
  },
  methods: {
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },

    resetSearch() {
      this.searchParams = {};
      this.searchAjax();
    },

    getList() {
      this.listLoading = true;
      let data = JSON.parse(JSON.stringify(this.searchParams));
      // 结算日期
      if (data.settlementDate && data.settlementDate[0]) {
        data.settlementDateStart = data.settlementDate[0];
        data.settlementDateEnd = data.settlementDate[1];
      }
      delete data.settlementDate;
      this.$http({
        url: '/buz/settlementReport/read/page',
        type: 'POST',
        data: {
          ...data,
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          type: 3
        }
      })
        .then(res => {
          this.total = res.total;
          res.data.forEach(item => {
            item.orgIdStr = item.orgIdStr.split(',');
          });
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    // 回款/取消回款
    payment(row) {
      this.openPageTabTags('/orgSettlement/groupCommissionSettlement/subordinateDetail', {
        reportId: row.id,
        reportName: row.reportName,
        settlementDate: filter.filterTime(row.settlementDate, 'YYYY-MM-DD'), //结算日期
        orgName: row.orgName,
        roll: 1
      });
    },

    toDetailPage(row) {
      this.openPageTabTags('/orgSettlement/groupCommissionSettlement/subordinateDetail', {
        reportId: row.id,
        reportName: row.reportName,
        settlementDate: filter.filterTime(row.settlementDate, 'YYYY-MM-DD'), //结算日期
        orgName: row.orgName
      });
    },

    toBillDetail(row) {
      this.openPageTabTags('/orgSettlement/groupCommissionSettlement/subordinateBillDetail', {
        reportId: row.id,
        reportName: row.reportName,
        settlementDate: filter.filterTime(row.settlementDate, 'YYYY-MM-DD') //结算日期
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tableBox {
  margin-top: 15px;
}

.label {
  position: relative;
  .tip-icon {
    margin-left: 6px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: transparent;
    border: 1px solid #9c9c9c;
    color: #a8a6a6;
    display: inline-block;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    cursor: pointer;
    top: 50%;
  }
  .tip-icon:hover + .pop-tip {
    opacity: 0.9;
    z-index: 9999;
    display: block;
  }
  .pop-tip {
    position: absolute;
    width: 190px;
    bottom: -38px;
    display: flex;
    align-items: center;
    text-align: left;
    left: 50%;
    margin-left: -50px;
    padding: 3px 10px;
    display: flex;
    flex-direction: column;
    background-color: #444444;
    display: none;
    border-radius: 4px;
    span {
      font-size: 12px;
      font-weight: 500;
      color: #fff;
    }
    .arrow {
      position: absolute;
      width: 12px;
      height: 12px;
      background-color: #444444;
      opacity: 0.9;
      top: -4px;
      left: 66px;
      transform: rotateZ(135deg);
    }
  }
}
</style>
